import React from 'react';

const Footer = () => {
    return (
        <div className='bg-black text-white mt-5 py-3 text-center'>
        <p>CopyRight © 2022 Teaching Tone, All Rights Reserved</p>
        <br />
        <p>Have any question? +8801622512674</p>
    </div>
    );
};

export default Footer;